var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAverageScore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.022,
    height: 21.05,
    viewBox: "0 0 24.022 21.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tachometer-average",
    d: "M20,4.052C8.353-5.659-6.712,9.5,3.138,21.081A2.318,2.318,0,0,0,7.1,20.616c.347-.519.682-1.687,1.486-1.616H15.41c.8-.074,1.161,1.129,1.5,1.646A2.367,2.367,0,0,0,19,22a2.734,2.734,0,0,0,1.814-.867A12.058,12.058,0,0,0,20,4.052ZM12,15a2.008,2.008,0,0,1-1-3.732V6a1,1,0,0,1,2,0v5.268A2.008,2.008,0,0,1,12,15Z",
    transform: "translate(0.05 -0.95)",
    fill: "#136ad0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageScore);
export default __webpack_public_path__ + "static/media/average-score.c5030f54e5a46d5cbeb6bffbead81de4.svg";
export { ForwardRef as ReactComponent };